import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-jianguo",
  "use": "icon-jianguo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-jianguo\"><defs><style type=\"text/css\"></style></defs><path d=\"M870.4 243.2s-6.4-44.8-51.2-108.8c-6.4 6.4-12.8 6.4-19.2 0 0 0-38.4-12.8-76.8 12.8s-64 76.8-76.8 160c-12.8 134.4-76.8 211.2-179.2 281.6-83.2 57.6-96 224-96 224 0 12.8-12.8 19.2-25.6 19.2s-25.6-12.8-19.2-25.6c0-6.4 12.8-185.6 115.2-262.4 89.6-64 147.2-128 160-249.6 12.8-96 44.8-160 96-192 25.6-19.2 57.6-19.2 76.8-19.2-6.4-6.4-12.8-12.8-25.6-19.2-153.6-96-390.4 25.6-524.8 268.8s-108.8 524.8 44.8 627.2c160 96 396.8-19.2 524.8-268.8 89.6-153.6 108.8-320 76.8-448z\" fill=\"#8a8a8a\" p-id=\"72112\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jianguo.svg
// module id = Ymmd
// module chunks = 22